var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.isSquared ? '' : 'is-rounded',attrs:{"src":_vm._f("asAvatar")(_vm.dna),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }